import { useMemo } from 'react';

import { dashboardSidebarMenuConfig } from 'configs';
import { useFeatureToggles } from 'hooks/unleash.hook';
import { INavItem } from 'models';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { arrayIntersect } from 'utils';

export const useAuthSidebarMenu = (): [INavItem[]] => {
  const initialMenuItems = dashboardSidebarMenuConfig;
  const { userRoles } = useAppSelector(selectCurrentUserInfo);
  const { dashboard, serviceInterruptions } = useFeatureToggles();

  let menuItems = initialMenuItems.filter((menu) => {
    return menu.roles.length === 0 || arrayIntersect(userRoles as any[], menu.roles, 'name').length !== 0;
  });

  if (!dashboard) menuItems = menuItems.filter((item) => item.id !== 'dashboard');

  if (!serviceInterruptions) menuItems = menuItems.filter((item) => item.id !== 'interruptions');

  return useMemo(() => [menuItems], [menuItems]);
};
